var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-app-wrapper"},[_c('div',{staticClass:"app-content"},[_c('base-header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('base-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }